export default "__VITE_ASSET__7b448717__"